'use client';

export { default } from "./useLazyRipple.js";